import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { SearchConfig } from '@spartacus/core';
import { Converter, EntitiesModel } from '@spartacus/core';
import { OccEndpointsService, ConverterService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { Branch, BranchesList, BranchForm, StoreLocatorFeatureGroup } from '../uig-branches/uig-branches.models';

export const UIG_BRANCH_NORMALIZER = new InjectionToken<Converter<any, Branch>>(
  'BranchNormalizer'
);

export const UIG_BRANCHES_NORMALIZER = new InjectionToken<
  Converter<any, EntitiesModel<Branch>>
>('BranchesListNormalizer');

@Injectable()
export class UigBranchesAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) { }

  getUigBranches(params?: SearchConfig): Observable<BranchesList> {
    return this.http.get<BranchesList>(
      this.occEndpoints.buildUrl('uigBranches', {queryParams: params})
    );
  }

  getUigBranchDetails(name: string): Observable<BranchForm> {
    return this.http.get<BranchForm>(
      this.occEndpoints.buildUrl('uigBranchDetails', {queryParams: {name}})
    );
  }

  deleteBranch(name: string): Observable<Boolean> {
    return this.http.delete<Boolean>(
      this.occEndpoints.buildUrl('uigBranchDelete', {queryParams: {name}})
    );
  }

  createOrUpdateBranch(branch: BranchForm): Observable<Boolean> {
    return this.http.post<Boolean>(
      this.occEndpoints.buildUrl('uigBranchCreateOrUpdate'),
      branch
    );
  }

  getStoreLocatorFeatureGroups(): Observable<StoreLocatorFeatureGroup[]> {
    return this.http.get<StoreLocatorFeatureGroup[]>(
      this.occEndpoints.buildUrl('uigStoreLocatorFeatureGroups')
    );
  }
}
